// src/array.ts
function toArray(v) {
  if (!v)
    return [];
  return Array.isArray(v) ? v : [v];
}
var fromLength = (length) => Array.from(Array(length).keys());
var first = (v) => v[0];
var last = (v) => v[v.length - 1];
var isEmpty = (v) => v.length === 0;
var has = (v, t) => v.indexOf(t) !== -1;
var add = (v, ...items) => v.concat(items);
var remove = (v, item) => v.filter((t) => t !== item);
var removeAt = (v, i) => v.filter((_, idx) => idx !== i);
var addOrRemove = (v, item) => {
  if (has(v, item))
    return remove(v, item);
  return add(v, item);
};
function clear(v) {
  while (v.length > 0)
    v.pop();
  return v;
}
function nextIndex(v, idx, opts = {}) {
  const { step = 1, loop = true } = opts;
  const next2 = idx + step;
  const len = v.length;
  const last2 = len - 1;
  if (idx === -1)
    return step > 0 ? 0 : last2;
  if (next2 < 0)
    return loop ? last2 : 0;
  if (next2 >= len)
    return loop ? 0 : idx > len ? len : idx;
  return next2;
}
function next(v, idx, opts = {}) {
  return v[nextIndex(v, idx, opts)];
}
function prevIndex(v, idx, opts = {}) {
  const { step = 1, loop = true } = opts;
  return nextIndex(v, idx, { step: -step, loop });
}
function prev(v, index, opts = {}) {
  return v[prevIndex(v, index, opts)];
}
var chunk = (v, size) => {
  const res = [];
  return v.reduce((rows, value, index) => {
    if (index % size === 0)
      rows.push([value]);
    else
      last(rows)?.push(value);
    return rows;
  }, res);
};

// src/equal.ts
var isEqual = (a, b) => {
  if (Object.is(a, b))
    return true;
  if (!(a instanceof Object) || !(b instanceof Object))
    return false;
  const keys = Object.keys(a);
  const length = keys.length;
  for (let i = 0; i < length; i++) {
    if (!(keys[i] in b))
      return false;
  }
  for (let i = 0; i < length; i++) {
    if (a[keys[i]] !== b[keys[i]])
      return false;
  }
  return length === Object.keys(b).length;
};

// src/functions.ts
var runIfFn = (v, ...a) => {
  const res = typeof v === "function" ? v(...a) : v;
  return res ?? void 0;
};
var cast = (v) => v;
var noop = () => {
};
var callAll = (...fns) => (...a) => {
  fns.forEach(function(fn) {
    fn?.(...a);
  });
};
var uuid = /* @__PURE__ */ (() => {
  let id = 0;
  return () => {
    id++;
    return id.toString(36);
  };
})();
function match(key, record, ...args) {
  if (key in record) {
    const fn = record[key];
    return typeof fn === "function" ? fn(...args) : fn;
  }
  const error = new Error(`No matching key: ${JSON.stringify(key)} in ${JSON.stringify(Object.keys(record))}`);
  Error.captureStackTrace?.(error, match);
  throw error;
}
var tryCatch = (fn, fallback) => {
  try {
    return fn();
  } catch (error) {
    if (error instanceof Error) {
      Error.captureStackTrace?.(error, tryCatch);
    }
    return fallback?.();
  }
};

// src/guard.ts
var isDev = () => process.env.NODE_ENV !== "production";
var isArray = (v) => Array.isArray(v);
var isBoolean = (v) => v === true || v === false;
var isObject = (v) => !(v == null || typeof v !== "object" || isArray(v));
var isNumber = (v) => typeof v === "number" && !Number.isNaN(v);
var isString = (v) => typeof v === "string";
var isFunction = (v) => typeof v === "function";
var hasProp = (obj, prop) => Object.prototype.hasOwnProperty.call(obj, prop);

// src/object.ts
function compact(obj) {
  if (!isPlainObject(obj) || obj === void 0) {
    return obj;
  }
  const keys = Reflect.ownKeys(obj).filter((key) => typeof key === "string");
  const filtered = {};
  for (const key of keys) {
    const value = obj[key];
    if (value !== void 0) {
      filtered[key] = compact(value);
    }
  }
  return filtered;
}
function json(value) {
  return JSON.parse(JSON.stringify(value));
}
var isPlainObject = (value) => {
  return value && typeof value === "object" && value.constructor === Object;
};

// src/warning.ts
function warn(...a) {
  const m = a.length === 1 ? a[0] : a[1];
  const c = a.length === 2 ? a[0] : true;
  if (c && process.env.NODE_ENV !== "production") {
    console.warn(m);
  }
}
function invariant(...a) {
  const m = a.length === 1 ? a[0] : a[1];
  const c = a.length === 2 ? a[0] : true;
  if (c && process.env.NODE_ENV !== "production") {
    throw new Error(m);
  }
}
export {
  add,
  addOrRemove,
  callAll,
  cast,
  chunk,
  clear,
  compact,
  first,
  fromLength,
  has,
  hasProp,
  invariant,
  isArray,
  isBoolean,
  isDev,
  isEmpty,
  isEqual,
  isFunction,
  isNumber,
  isObject,
  isString,
  json,
  last,
  match,
  next,
  nextIndex,
  noop,
  prev,
  prevIndex,
  remove,
  removeAt,
  runIfFn,
  toArray,
  tryCatch,
  uuid,
  warn
};
//# sourceMappingURL=index.mjs.map